export const STUDENT_DISCOUNT_PATHS = {
  nl: '/studentenkorting/verificatie',
  en: '/en/student-discount/verification',
  fr: '/fr/reduction-etudiant/verification',
  de: '/de/studentenrabatt/verifizierung'
};
